<div class="container">
  <h4>Manage Users</h4>
  <form>
    <div class="page-search mb-3">
      <div class="input-group">
        <input
          autofocus
          placeholder="Search Users"
          id="txtSearch"
          class="form-control"
          type="text"
          [formControl]="filter"
        />
        <button
          type="button"
          class="btn btn-sm btn-input-group"
          (click)="clearSearch()"
        >
          <fa-icon [icon]="icons.times"></fa-icon>
        </button>
      </div>
      <button
        type="button"
        [routerLink]="['add']"
        class="btn btn-outline-info btn-sm d-none d-md-block"
        [disabled]="!adminService.isReady"
      >
        <fa-icon [icon]="icons.add"></fa-icon>
      </button>
    </div>
  </form>
  <div class="">
    <ngb-alert
      type="info"
      [hidden]="this.adminService.isReady"
      [dismissible]="false"
      ><fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
      Reloading Users...</ngb-alert
    >
    <table
      class="table table-sm table-bordered table-striped table-row-detail table-hover"
    >
      <thead class="table-dark">
        <tr>
          <th>
            <div class="clearfix">
              <div class="float-start pt-2">
                <span class="">User Name</span>
              </div>
              <div class="float-end">
                <button
                  type="button"
                  [routerLink]="['add']"
                  class="btn btn-info btn-sm d-block d-md-none"
                  [disabled]="!adminService.isReady"
                >
                  <fa-icon [icon]="icons.add"></fa-icon>
                </button>
              </div>
            </div>
          </th>
          <th class="d-none d-md-table-cell">Email</th>
          <th class="d-none d-md-table-cell">User ID</th>
          <th class="d-none d-md-table-cell">Mobile Phone</th>
        </tr>
      </thead>
      <tbody>
        @for (user of this.filteredUsers | async; track user) {
          <tr [routerLink]="[user.Id]">
            <td>{{ user.Name }}</td>
            <td class="d-none d-md-table-cell">{{ user.EmailAddress }}</td>
            <td class="d-none d-md-table-cell">{{ user.Upn }}</td>
            <td class="d-none d-md-table-cell">
              {{ formatUserMobile(user) }}
              <!-- {{ user.Mobile ? phoneCodeMap.get(user.Country.Id) : "" }}
              {{ user.Mobile | mask: phoneMaskMap.get(user.Country.Id) }} -->
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
